import { css } from '@emotion/react';
import { semantic_colors, shapes } from '../../foundation';
import { getAutoColorCode } from '../../styles';

const { hover, pressed } = getAutoColorCode(semantic_colors.background.surface);

export const copy_text_base_css = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border: 1px solid transparent;
  background-color: transparent;
  transition: all 0.1s linear;
  cursor: pointer;
  padding: 0;
  border: 0;
  position: relative;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    width: calc(100% + 4px);
    height: 100%;
    z-index: -1;
    cursor: pointer;
    pointer-events: auto;
    transition: all 0.1s linear;
    ${shapes.border_radius.xsmall};
  }
  &:before {
    left: -4px;
  }
  &:after {
    right: -4px;
  }
  &:hover:not([disabled]):not(.copied) {
    .copy-icon {
      path {
        fill: ${semantic_colors.accent.primary};
      }
    }
    &:before,
    &:after {
      background-color: ${hover};
    }
  }
  &:active:not([disabled]):not(.copied) {
    &:before,
    &:after {
      background-color: ${pressed};
    }
  }
  &:focus {
    outline: 3px solid ${semantic_colors.tab_focus};
    box-shadow: none;
  }
  &:focus:not(:focus-visible) {
    outline: none;
  }
  &:disabled {
    cursor: not-allowed;
    &:before,
    &:after {
      cursor: not-allowed;
    }
  }
  &.copied {
    cursor: default;
    &:before,
    &:after {
      cursor: default;
    }
  }
`;
